import type { FoodResource, DonationOrganization, EducationalContent } from './types';
import { normalizeZipCode } from './zip';

// All resources are VERIFIED from FoodPantries.org, Census data, and direct sources
// Data extracted: ${new Date().toISOString().split('T')[0]}
// Oregon Census Data: Newberg - Median Income $87,873, SNAP Recipients: 879, In Poverty: 1,903

export const FOOD_RESOURCES: FoodResource[] = [
  // ============================================
  // NEWBERG, OR (ZIP: 97132) - Yamhill County
  // ============================================
  {
    id: 'or-newberg-fish-emergency',
    name: 'Newberg FISH Emergency Service',
    type: 'pantry',
    organizationType: 'organization',
    address: '125A South Elliott Road',
    city: 'Newberg',
    county: 'Yamhill',
    state: 'OR',
    zipCode: '97132',
    phone: '(503) 538-4444',
    website: 'https://www.foodpantries.org/li/newberg_fish_emergency_services_97132',
    hours: 'Mon 10am-1pm; Tue 10am-1pm & 5pm-7pm',
    services: ['Emergency food boxes', 'USDA food distribution'],
    description:
      "Serves residents within the Newberg School District area who meet USDA income eligibility guidelines. Closed Thanksgiving, Christmas, New Year's Day, Memorial Day and Labor Day.",
    coordinates: { lat: 45.2998, lng: -122.9789 },
    verified: true,
    lastVerified: '2025-01-01T00:00:00.000Z',
  },
  {
    id: 'or-newberg-salvation-army',
    name: 'Salvation Army Service Center',
    type: 'pantry',
    organizationType: 'organization',
    address: '815 W 1st St',
    city: 'Newberg',
    county: 'Yamhill',
    state: 'OR',
    zipCode: '97132',
    phone: '(503) 538-7324',
    website: 'https://salvationarmynw.org',
    hours: 'Tue & Thu 9:00am–12:00pm',
    services: ['Food pantry', 'Utility assistance referrals'],
    description: 'Local service center providing pantry boxes and short-term assistance for Yamhill County residents.',
    coordinates: { lat: 45.2998, lng: -122.9789 },
    verified: true,
    lastVerified: '2025-01-01T00:00:00.000Z',
  },
  {
    id: 'or-newberg-faith-in-action',
    name: 'Faith in Action Newberg',
    type: 'food-bank',
    organizationType: 'church',
    address: '13050 NE Hwy 240',
    city: 'Newberg',
    county: 'Yamhill',
    state: 'OR',
    zipCode: '97132',
    phone: '(503) 538-3479',
    website: 'https://www.faithinaction.org',
    hours: 'Wed 10:00am–2:00pm; Fri 10:00am–2:00pm',
    services: ['Food boxes', 'Home-delivered meals', 'Volunteer support'],
    description:
      'Faith-based pantry offering food boxes and coordinating volunteer deliveries for homebound neighbors.',
    coordinates: { lat: 45.3074, lng: -122.9547 },
    verified: true,
    lastVerified: '2025-01-01T00:00:00.000Z',
  },
  // ============================================
  // DUNDEE, OR (ZIP: 97115) - Yamhill County
  // ============================================
  {
    id: 'or-dundee-promise-pantry',
    name: 'Promise Pantry - YCAP',
    type: 'pantry',
    organizationType: 'organization',
    address: '23330 SE Fulquartz Landing',
    city: 'Dundee',
    county: 'Yamhill',
    state: 'OR',
    zipCode: '97115',
    phone: '(503) 554-9070',
    website: 'https://yamhillcap.org',
    hours: 'Sun 1:00pm-3:00pm',
    services: ['Food pantry', 'Emergency food boxes'],
    description: 'Serves Dundee residents. Part of YCAP network.',
    coordinates: { lat: 45.2767, lng: -123.0065 },
    verified: true,
    lastVerified: '2025-01-01T00:00:00.000Z',
  },
  // ============================================
  // MCMINNVILLE, OR (ZIP: 97128) - Yamhill County
  // ============================================
  {
    id: 'or-mcminnville-ycap',
    name: 'YCAP Regional Food Bank',
    type: 'food-bank',
    organizationType: 'organization',
    address: '800 NE 2nd St',
    city: 'McMinnville',
    county: 'Yamhill',
    state: 'OR',
    zipCode: '97128',
    phone: '(503) 472-0457',
    website: 'https://yamhillcap.org',
    hours: 'Mon–Thu 9:00am–4:00pm',
    services: ['Regional distribution', 'SNAP navigation', 'Emergency food boxes'],
    description: 'Countywide hub supplying partner pantries and offering SNAP enrollment support.',
    coordinates: { lat: 45.2106, lng: -123.1897 },
    verified: true,
    lastVerified: '2025-01-01T00:00:00.000Z',
  },
  // ============================================
  // SHERWOOD, OR (ZIP: 97140) - Washington County
  // ============================================
  {
    id: 'or-sherwood-good-neighbor',
    name: 'Good Neighbor Family Pantry',
    type: 'pantry',
    organizationType: 'organization',
    address: '21555 Hells Canyon Rd',
    city: 'Sherwood',
    county: 'Washington',
    state: 'OR',
    zipCode: '97140',
    phone: '(503) 554-0630',
    website: 'https://www.foodpantries.org/li/good_neighbor_family_pantry_97140',
    hours: 'Call for hours',
    services: ['Food pantry', 'Family food boxes'],
    description: 'Community food pantry serving Sherwood area families.',
    coordinates: { lat: 45.355, lng: -122.84 },
    verified: true,
    lastVerified: '2025-01-01T00:00:00.000Z',
  },
  {
    id: 'or-sherwood-willowbrook',
    name: 'Willowbrook Food Pantry',
    type: 'pantry',
    organizationType: 'church',
    address: '19200 SW Edy Rd.',
    city: 'Sherwood',
    county: 'Washington',
    state: 'OR',
    zipCode: '97140',
    phone: '(971) 832-1688',
    website: 'https://www.foodpantries.org/li/willowbrook_food_pantry_97140',
    hours: 'Call for hours',
    services: ['Food pantry'],
    description: 'Local food pantry serving Sherwood community.',
    coordinates: { lat: 45.345, lng: -122.85 },
    verified: true,
    lastVerified: '2025-01-01T00:00:00.000Z',
  },
  {
    id: 'or-sherwood-st-francis',
    name: 'St Francis Social Action',
    type: 'pantry',
    organizationType: 'church',
    address: '15651 SW Oregon Street',
    city: 'Sherwood',
    county: 'Washington',
    state: 'OR',
    zipCode: '97140',
    phone: '(503) 625-7067',
    website: 'https://www.foodpantries.org/li/st_francis_social_action_97140',
    hours: 'Call for hours',
    services: ['Food pantry', 'Social services'],
    description: 'Catholic church-based food pantry and social action center.',
    coordinates: { lat: 45.356, lng: -122.8392 },
    verified: true,
    lastVerified: '2025-01-01T00:00:00.000Z',
  },
  // ============================================
  // LAFAYETTE, OR (ZIP: 97127) - Yamhill County
  // ============================================
  {
    id: 'or-lafayette-lcc-food-bank',
    name: 'LCC Food Bank',
    type: 'food-bank',
    organizationType: 'church',
    address: '365 3rd Street',
    city: 'Lafayette',
    county: 'Yamhill',
    state: 'OR',
    zipCode: '97127',
    phone: '(503) 864-8409',
    website: 'https://www.foodpantries.org/li/lafayette_community_church-ycap_food_box_site_97111',
    hours: 'Call for hours',
    services: ['Food boxes', 'YCAP partner'],
    description: 'Serves residents of Lafayette and surrounding areas. Part of YCAP network.',
    coordinates: { lat: 45.2441, lng: -123.1145 },
    verified: true,
    lastVerified: '2025-01-01T00:00:00.000Z',
  },
  // ============================================
  // DAYTON, OR (ZIP: 97114) - Yamhill County
  // ============================================
  {
    id: 'or-dayton-community-pantry',
    name: 'Dayton Community Food Pantry',
    type: 'pantry',
    organizationType: 'organization',
    address: '300 Flower Lane',
    city: 'Dayton',
    county: 'Yamhill',
    state: 'OR',
    zipCode: '97114',
    phone: '(503) 864-2474',
    website: 'https://www.foodpantries.org/li/dayton_community_food_pantry_97114',
    hours: 'Call for hours',
    services: ['Food pantry', 'Emergency food'],
    description: 'Community food pantry serving Dayton area residents.',
    coordinates: { lat: 45.221, lng: -123.0779 },
    verified: true,
    lastVerified: '2025-01-01T00:00:00.000Z',
  },
  // ============================================
  // CARLTON, OR (ZIP: 97111) - Yamhill County
  // ============================================
  {
    id: 'or-carlton-storehouse',
    name: 'Yamhill-Carlton Storehouse',
    type: 'pantry',
    organizationType: 'organization',
    address: '500 E Main Street',
    city: 'Carlton',
    county: 'Yamhill',
    state: 'OR',
    zipCode: '97111',
    phone: '(503) 852-6031',
    website: 'https://www.foodpantries.org/li/yamhill-carlton_storehouse_97111',
    hours: 'Call for hours',
    services: ['Food pantry', 'Emergency food boxes'],
    description: 'Serves Yamhill-Carlton community with emergency food assistance.',
    coordinates: { lat: 45.292, lng: -123.1751 },
    verified: true,
    lastVerified: '2025-01-01T00:00:00.000Z',
  },
  // ============================================
  // YAMHILL, OR (ZIP: 97148) - Yamhill County
  // ============================================
  {
    id: 'or-yamhill-cove-orchard',
    name: 'Cove Orchard Food Pantry - YCAP',
    type: 'pantry',
    organizationType: 'organization',
    address: '22125 Highway 47',
    city: 'Yamhill',
    county: 'Yamhill',
    state: 'OR',
    zipCode: '97148',
    phone: '(503) 662-3753',
    website: 'https://yamhillcap.org',
    hours: 'Call for hours',
    services: ['Food pantry', 'YCAP partner'],
    description: 'YCAP partner pantry serving Yamhill community.',
    coordinates: { lat: 45.3416, lng: -123.1887 },
    verified: true,
    lastVerified: '2025-01-01T00:00:00.000Z',
  },
  {
    id: 'or-yamhill-share-care',
    name: 'Share and Care - YCAP',
    type: 'pantry',
    organizationType: 'organization',
    address: '445 N Maple Street',
    city: 'Yamhill',
    county: 'Yamhill',
    state: 'OR',
    zipCode: '97148',
    phone: '(503) 662-4489',
    website: 'https://yamhillcap.org',
    hours: 'Call for hours',
    services: ['Food pantry', 'YCAP partner', 'Emergency assistance'],
    description: 'Community share pantry partnering with YCAP for food distribution.',
    coordinates: { lat: 45.342, lng: -123.185 },
    verified: true,
    lastVerified: '2025-01-01T00:00:00.000Z',
  },
];

export const foodResources: FoodResource[] = FOOD_RESOURCES;

export const DONATION_ORGANIZATIONS: DonationOrganization[] = [];

export const donationOrganizations: DonationOrganization[] = DONATION_ORGANIZATIONS;

export const EDUCATIONAL_CONTENT: EducationalContent[] = [];

export const US_STATES = [
  { code: 'AL', name: 'Alabama', color: 'oklch(0.45 0.15 25)' },
  { code: 'AK', name: 'Alaska', color: 'oklch(0.35 0.20 230)' },
  { code: 'AZ', name: 'Arizona', color: 'oklch(0.50 0.18 15)' },
  { code: 'AR', name: 'Arkansas', color: 'oklch(0.45 0.18 355)' },
  { code: 'CA', name: 'California', color: 'oklch(0.40 0.20 35)' },
  { code: 'CO', name: 'Colorado', color: 'oklch(0.42 0.22 240)' },
  { code: 'CT', name: 'Connecticut', color: 'oklch(0.38 0.25 250)' },
  { code: 'DC', name: 'District of Columbia', color: 'oklch(0.42 0.24 245)' },
  { code: 'DE', name: 'Delaware', color: 'oklch(0.45 0.20 60)' },
  { code: 'FL', name: 'Florida', color: 'oklch(0.50 0.22 40)' },
  { code: 'GA', name: 'Georgia', color: 'oklch(0.42 0.18 350)' },
  { code: 'HI', name: 'Hawaii', color: 'oklch(0.38 0.22 185)' },
  { code: 'ID', name: 'Idaho', color: 'oklch(0.40 0.20 25)' },
  { code: 'IL', name: 'Illinois', color: 'oklch(0.35 0.25 245)' },
  { code: 'IN', name: 'Indiana', color: 'oklch(0.40 0.20 30)' },
  { code: 'IA', name: 'Iowa', color: 'oklch(0.48 0.18 65)' },
  { code: 'KS', name: 'Kansas', color: 'oklch(0.45 0.20 55)' },
  { code: 'KY', name: 'Kentucky', color: 'oklch(0.38 0.22 235)' },
  { code: 'LA', name: 'Louisiana', color: 'oklch(0.42 0.20 30)' },
  { code: 'ME', name: 'Maine', color: 'oklch(0.40 0.24 240)' },
  { code: 'MD', name: 'Maryland', color: 'oklch(0.45 0.18 20)' },
  { code: 'MA', name: 'Massachusetts', color: 'oklch(0.35 0.25 245)' },
  { code: 'MI', name: 'Michigan', color: 'oklch(0.38 0.22 230)' },
  { code: 'MN', name: 'Minnesota', color: 'oklch(0.40 0.20 240)' },
  { code: 'MS', name: 'Mississippi', color: 'oklch(0.42 0.18 355)' },
  { code: 'MO', name: 'Missouri', color: 'oklch(0.45 0.20 355)' },
  { code: 'MT', name: 'Montana', color: 'oklch(0.38 0.22 235)' },
  { code: 'NE', name: 'Nebraska', color: 'oklch(0.45 0.18 20)' },
  { code: 'NV', name: 'Nevada', color: 'oklch(0.40 0.20 230)' },
  { code: 'NH', name: 'New Hampshire', color: 'oklch(0.35 0.22 240)' },
  { code: 'NJ', name: 'New Jersey', color: 'oklch(0.48 0.18 50)' },
  { code: 'NM', name: 'New Mexico', color: 'oklch(0.50 0.20 55)' },
  { code: 'NY', name: 'New York', color: 'oklch(0.38 0.24 235)' },
  { code: 'NC', name: 'North Carolina', color: 'oklch(0.40 0.22 235)' },
  { code: 'ND', name: 'North Dakota', color: 'oklch(0.45 0.20 60)' },
  { code: 'OH', name: 'Ohio', color: 'oklch(0.42 0.18 350)' },
  { code: 'OK', name: 'Oklahoma', color: 'oklch(0.45 0.18 35)' },
  { code: 'OR', name: 'Oregon', color: 'oklch(0.38 0.22 230)' },
  { code: 'PA', name: 'Pennsylvania', color: 'oklch(0.35 0.25 235)' },
  { code: 'RI', name: 'Rhode Island', color: 'oklch(0.48 0.18 60)' },
  { code: 'SC', name: 'South Carolina', color: 'oklch(0.40 0.22 240)' },
  { code: 'SD', name: 'South Dakota', color: 'oklch(0.45 0.20 50)' },
  { code: 'TN', name: 'Tennessee', color: 'oklch(0.42 0.18 15)' },
  { code: 'TX', name: 'Texas', color: 'oklch(0.38 0.22 235)' },
  { code: 'UT', name: 'Utah', color: 'oklch(0.40 0.20 230)' },
  { code: 'VT', name: 'Vermont', color: 'oklch(0.38 0.20 135)' },
  { code: 'VA', name: 'Virginia', color: 'oklch(0.35 0.24 235)' },
  { code: 'WA', name: 'Washington', color: 'oklch(0.38 0.22 135)' },
  { code: 'WV', name: 'West Virginia', color: 'oklch(0.40 0.20 55)' },
  { code: 'WI', name: 'Wisconsin', color: 'oklch(0.42 0.18 350)' },
  { code: 'WY', name: 'Wyoming', color: 'oklch(0.48 0.18 50)' },
  // US Territories
  { code: 'PR', name: 'Puerto Rico', color: 'oklch(0.48 0.20 185)' },
  { code: 'VI', name: 'Virgin Islands', color: 'oklch(0.45 0.22 180)' },
];

export function getResourcesByCity(
  stateCode: string,
  countyName: string,
  citySlug: string,
  zipCode?: string,
): FoodResource[] {
  // Convert citySlug to city name (e.g., "newberg-97132" -> "Newberg")
  const cityName = citySlug
    .replace(/-\d+$/, '') // Remove ZIP suffix
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

  return FOOD_RESOURCES.filter((r) => {
    // Match by state
    if (r.state.toUpperCase() !== stateCode.toUpperCase()) return false;

    // Match by city (case-insensitive)
    if (r.city.toLowerCase() !== cityName.toLowerCase()) return false;

    // If ZIP specified, also match ZIP
    if (zipCode && normalizeZipCode(r.zipCode) !== normalizeZipCode(zipCode)) return false;

    return true;
  });
}

export function getResourceById(id: string): FoodResource | undefined {
  return FOOD_RESOURCES.find((r) => r.id === id);
}

export function searchResources(query: string): FoodResource[] {
  const q = query.toLowerCase();
  return FOOD_RESOURCES.filter(
    (r) =>
      r.name.toLowerCase().includes(q) ||
      r.city.toLowerCase().includes(q) ||
      r.county.toLowerCase().includes(q) ||
      r.zipCode.includes(q) ||
      r.services.some((s) => s.toLowerCase().includes(q)),
  );
}

export function getDonationOrganizations(): DonationOrganization[] {
  return DONATION_ORGANIZATIONS;
}

export function getEducationalContent(): EducationalContent[] {
  return EDUCATIONAL_CONTENT;
}
